import { ShimmerEffect } from "components/shimmer";
import { cn } from "utils";

export function LogByDayLoader({ cardCount = 3 }) {
  return (
    <div
      role="region"
      aria-label="Timesheet entries"
      className={"lg:pt-6 pt-4 "}
    >
      <div className={"flex flex-col gap-6 lg:px-6 px-4"}>
        <div className="flex justify-between md:items-center md:gap-6 gap-4 md:flex-row flex-col">
          <div>
            <ShimmerEffect className="w-40 h-6.5  " />
            <ShimmerEffect className="w-20 h-6.5 mt-2 " />
          </div>
        </div>
      </div>
      <div
        role="list"
        aria-label="Timesheet entries list"
        className={
          "mt-4 pl-4 lg:pl-6 flex gap-4.5 overflow-x-auto no-scrollbar py-1"
        }
      >
        {Array.from({ length: Math.floor(Math.random() * cardCount) + 2 }).map(
          (_, cardIndex) => (
            <ShimmerEffect
              key={cardIndex}
              className={cn(
                "flex-shrink-0 w-80 h-40 rounded-lg overflow-hidden"
              )}
            />
          )
        )}

        <div className="sr-only">Loading timesheet entries...</div>
      </div>
    </div>
  );
}
